import { type ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryProvider } from '@/app/providers/ReactQueryProvider';
import { StoreProvider } from '@/app/providers/StoreProvider';
import { TelegramProvider } from './providers/TelegramProvider';
import { AppLoader } from '@/app/AppLoader';
import { AppRouter } from './router';
// import { VConsoleProvider } from './providers/VConsoleProvider';
import ProfileMenu from '@/components/ProfileMenu/ProfileMenu';
import NavMenu from '@/components/NavMenu/NavMenu';
import NotificationWrapper from '@/components/Notifications/NotificationWrapper';

interface AppProps {
  children?: ReactNode;
}

const App = ({ children }: AppProps) => {
  return (
    // <VConsoleProvider>
      <BrowserRouter>
        <TelegramProvider>
          <ReactQueryProvider>
            <StoreProvider>
              <AppLoader>
                <div>
                  <ProfileMenu />
                  <AppRouter />
                  <NotificationWrapper />
                  {children}
                  <NavMenu />
                </div>
              </AppLoader>
            </StoreProvider>
          </ReactQueryProvider>
        </TelegramProvider>
      </BrowserRouter>
    // </VConsoleProvider>
  );
};

export default App;
